import { makeStyles } from "@material-ui/styles";
import { setFontColorOnBg } from "../../CustomHooks/useThemeHook";

const useStyles = makeStyles((theme) => ({
  customPopup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: theme?.palette?.modal?.modalBorderRadius || "12px",
    border: theme?.palette?.modal?.modalBorder ? "1px solid black" : null,
  },
  customText: {
    color: '#ffffff',
    background: '#000',
    textAlign: 'center',
  },
  customAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme?.palette?.common?.background,
  },
  customRightAction: {
    display: 'flex',
    background: '#000',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  actionText: {
    fontWeight: "bold",
    color: theme?.palette?.common?.themeFontColor,
  },
  updateActionText: {
    fontWeight: "bold",
    backgroundColor: "#99d98c",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#b5e48c",
    },
  },
  placeholderImg: {
    maxHeight: "370px",
    width: "100%",
    margin: "5px",
  },
  imgDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme?.palette?.common?.background,
  },
  readyToPayBtn: {
    background: "#e63946",
    "&:hover": {
      backgroundColor: "#c1121f",
      cursor: "pointer",
    },
  },
  okActionText: {
    fontWeight: "bold",
    backgroundColor: theme?.palette?.button?.buttonColor || "black",
    color: setFontColorOnBg(theme?.palette?.button?.buttonColor || "#000000"),
    borderRadius: theme?.palette?.button?.borderRadius || "12px",
    border: theme?.palette?.button?.buttonBorder ? "1px solid black" : null,
    "&:hover": {
      backgroundColor: "#000",
      color: "#fff",
      cursor: "pointer",
    },
  },
  getItFreeBtn: {
    background: "#8cb369",
    "&:hover": {
      backgroundColor: "#6a994e",
      cursor: "pointer",
    },
  },
  paper: {
    top: 0,
    left: 0,
    right: 0,
    border: '1px solid black',
    bottom: 0,
    height: '100%',
    margin: 'auto',
    zIndex: 20000,
    position: 'fixed',
    maxWidth: '500px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.08)',
    borderRadius: '12px',
    backgroundColor: '#000',
  },
  item: {
    color: 'white',
    width: '100%',
    border: '1px solid black',
    cursor: 'pointer',
    display: 'flex',
    padding: '10px',
    flexGrow: 1,
    alignItems: 'center',
    userSelect: 'none',
    marginRight: '10px',
    borderRadius: '12px',
    flexDirection: 'row',
    backgroundColor: '#000',
  },
  continueBtn: {
    color: 'white !important',
    width: '100%',
    border: '1px solid black',
    height: '50px',
    margin: '4px 4px',
    display: 'flex',
    fontSize: 14,
    boxShadow: 'none',
    marginTop: '20px',
    alignItems: 'center',
    borderRadius: '12px',
    textTransform: 'none',
    justifyContent: 'center',
    backgroundColor: '#414a50',
  },
  btn: {
    color: 'white',
    border: '1px solid black',
    margin: '0px 0px 0px 10px',
    fontSize: 14,
    borderRadius: 10,
    textTransform: 'none',
    textDecoration: 'none',
    backgroundColor: '#000',
  },
  avatar: {
    color: '#f5f5f5',
    width: '35px',
    border: '1px solid black',
    cursor: 'pointer',
    height: '35px',
    display: 'flex',
    padding: 0,
    fontSize: 20,
    alignItems: 'center',
    marginLeft: '10px',
    marginRight: '10px',
    borderRadius: '50%',
    textTransform: 'capitalize',
    justifyContent: 'center',
    backgroundColor: '#000',
  },
}));

export default useStyles;
